module.exports = __webpack_public_path__ + "static/media/features-image.d90c1ac4.svg";